export const Logo = ({ size = 38 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <polygon points="96,50 73,90 27,90 4,50 27,10 73,10" fill="#1A3A5C" />
    <polygon points="90,50 69.5,84 30.5,84 10,50 30.5,16 69.5,16" fill="white" />
    <polygon points="84,50 65.5,78 34.5,78 16,50 34.5,22 65.5,22" fill="#8FA3B8" />
    <polygon points="77,50 61,72 39,72 23,50 39,28 61,28" fill="white" />
    <path d="M32 67 L32 38 L50 55 L68 38 L68 67" stroke="#1A3A5C" strokeWidth="9" strokeLinejoin="round" strokeLinecap="round" fill="none" />
  </svg>
);

const PARTICLES = [
  { dur: 26, del: 0, op: 0.16, sz: 70, left: "6%", stroke: "#00B4D8", sw: 1.6, glow: true },
  { dur: 22, del: 3, op: 0.1, sz: 110, left: "18%", stroke: "white", sw: 1 },
  { dur: 30, del: 7, op: 0.18, sz: 50, left: "33%", stroke: "#00B4D8", sw: 1.8, glow: true },
  { dur: 24, del: 1.5, op: 0.12, sz: 90, left: "48%", stroke: "white", sw: 1 },
  { dur: 34, del: 11, op: 0.08, sz: 140, left: "62%", stroke: "white", sw: 0.9 },
  { dur: 20, del: 5, op: 0.22, sz: 44, left: "74%", stroke: "#00B4D8", sw: 2, glow: true },
  { dur: 28, del: 9, op: 0.1, sz: 95, left: "86%", stroke: "white", sw: 1 },
  { dur: 19, del: 2, op: 0.2, sz: 56, left: "94%", stroke: "#00B4D8", sw: 1.6, glow: true },
  { dur: 32, del: 13, op: 0.09, sz: 120, left: "27%", stroke: "white", sw: 0.9 },
  { dur: 23, del: 6, op: 0.18, sz: 48, left: "55%", stroke: "#00B4D8", sw: 1.8, glow: true },
  { dur: 27, del: 4, op: 0.11, sz: 80, left: "40%", stroke: "white", sw: 1 },
  { dur: 21, del: 8, op: 0.2, sz: 52, left: "68%", stroke: "#00B4D8", sw: 1.8, glow: true },
];

export const HexBg = () => (
  <>
    <svg className="hex-canvas anim" viewBox="0 0 1400 900" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <defs>
        <pattern id="hexpat" x="0" y="0" width="84" height="96.7" patternUnits="userSpaceOnUse">
          <polygon points="42,4 80,25 80,71 42,92 4,71 4,25" fill="none" stroke="#5fd4ec" strokeWidth="1" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#hexpat)" />
    </svg>
    <div className="hero-gradient anim" aria-hidden="true"></div>
    <div className="hero-sweep" aria-hidden="true"></div>
    <div className="hex-particles" aria-hidden="true">
      {PARTICLES.map((p, i) => (
        <svg
          key={i}
          className={`hxp ${p.glow ? "glow" : ""}`}
          style={{ "--dur": `${p.dur}s`, "--del": `${p.del}s`, "--op": p.op, width: p.sz, height: p.sz, left: p.left, bottom: "-150px" }}
          viewBox="0 0 60 60"
        >
          <polygon points="30,3 57,18 57,42 30,57 3,42 3,18" fill="none" stroke={p.stroke} strokeWidth={p.sw} />
        </svg>
      ))}
    </div>
  </>
);

export const GlowLayer = () => (
  <div className="glow-layer" aria-hidden="true">
    <div className="glow-orb" style={{ width: 700, height: 700, top: -200, left: -200, "--orb-dur": "22s", "--dx1": "300px", "--dy1": "100px", "--dx2": "50px", "--dy2": "300px", "--dx3": "200px", "--dy3": "-50px" }}></div>
    <div className="glow-orb" style={{ width: 500, height: 500, bottom: -100, right: -100, "--orb-dur": "28s", "--dx1": "-200px", "--dy1": "-80px", "--dx2": "-80px", "--dy2": "-200px", "--dx3": "-150px", "--dy3": "60px" }}></div>
  </div>
);
